import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import _ from 'lodash';
gsap.registerPlugin(ScrollTrigger);

export default class Statistics {
	static init(e) {
		const els = e.detail.element.querySelectorAll('[data-statistics]');
		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;
		this.numbers = this.el.querySelectorAll('[data-number]');

		let mm = gsap.matchMedia();

		mm.add(
			{
				noReduceMotion: '(prefers-reduced-motion: no-preference)',
				reduceMotion: '(prefers-reduced-motion: reduce)',
			},
			(context) => {
				let { reduceMotion } = context.conditions;

				this.numbers.forEach((number) => {
					let clean = (v) => (v + '').replace(/[^\d\.-]/gi, ''), // get rid of anything except numbers and periods
						num = clean(number.getAttribute('data-number')),
						proxy = { val: 0 };

					gsap.to(proxy, {
						val: +num,
						duration: reduceMotion ? 0 : 1.5,
						scrollTrigger: {
							trigger: number,
							toggleActions: 'restart none none none',
						},
						onUpdate: () => (number.innerText = parseInt(proxy.val)),
					});
				});
			}
		);
	}
}
